import React from 'react';
import {Header, Breadcrumb, Loader, Segment, Tab, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Icon} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';
import CursoForm from "./CursoForm";
import CursoFormImagenes from "./CursoFormImagenes";
import ManageCrucigramaPalabrasList from "../crucigramapalabras/ManageCrucigramaPalabrasList";
import ManageJuegos from '../juegos/ManageJuegos';



const ExamenPanel=({strings, id, onChange, errors, datos, onSave, ajaxCallInProgress, color, form, permisos, archivos, onChangeCurrency,cursoCombo,tagCombo, headersTablaModulos, camposTablaModulos, validacionesTablaModulos, tipoTablaModulos, usuarioCombo, moduloCombo, fechas, verModulo, onBuscar,onHandleFileImagen, imgBanner, imgThumb, imgPresentacion, onSaveImage,cursoTipoCombo})=>{



     const panes = [
  {
    menuItem: 'Datos generales',
    render: () => <Tab.Pane attached="top">
       
         
         <CursoForm 
                    strings={strings}
                    id={id}
                    onChange={onChange}
                    errors={errors}
                    datos={datos}
                    onSave={onSave}      
                    ajaxCallInProgress={ajaxCallInProgress}
                    color={color}
                    form={form}
                    permisos={permisos}
                    archivos={archivos}
                    onChangeCurrency={onChangeCurrency}
                    cursoCombo={cursoCombo}
                    tagCombo={tagCombo}
                    headersTablaModulos={headersTablaModulos}
                    camposTablaModulos={camposTablaModulos}
                    validacionesTablaModulos={validacionesTablaModulos}
                    tipoTablaModulos={tipoTablaModulos}
                    usuarioCombo={usuarioCombo}
                    moduloCombo={moduloCombo}
                    fechas={fechas}
                    verModulo={verModulo}
                    onBuscar={onBuscar}
                    cursoTipoCombo={cursoTipoCombo}
                />
         
         </Tab.Pane>
  },
  {
    menuItem: 'Imagenes',
    render: () => 
        
        <Tab.Pane attached="top">
                  
         {id>0?
             <CursoFormImagenes 
                    strings={strings}
                    id={id}
                    onChange={onChange}
                    errors={errors}
                    datos={datos}
                    onSave={onSaveImage}      
                    ajaxCallInProgress={ajaxCallInProgress}
                    color={color}
                    form={form}
                    permisos={permisos}
                    archivos={archivos}
                    onChangeCurrency={onChangeCurrency}
                    cursoCombo={cursoCombo}
                    tagCombo={tagCombo}
                    usuarioCombo={usuarioCombo}
                    moduloCombo={moduloCombo}
                    fechas={fechas}
                    verModulo={verModulo}
                    onBuscar={onBuscar}
                    
                    onHandleFileImagen={onHandleFileImagen}
                    imgBanner={imgBanner}
                    imgThumb={imgThumb}
                    imgPresentacion={imgPresentacion}
                    
                />
            :
         
            <Header as='h2' icon  textAlign='center'>
                <Icon name='info circle' />
                {strings?strings["configuracion"]:""}
                <Header.Subheader>
                    {strings?strings["configuracion"]:""}
                </Header.Subheader>
            </Header>
         
         }
        </Tab.Pane>
       
  }
  
]
 
	return (
            <div>
            <Tab menu={{ attached: 'top' }} panes={panes} /> 
            </div>
        
	);
};



export default ExamenPanel;